export default __webpack_public_path__ + "static/media/gallery_08.18f78dcc.jpg";